import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { ActivityMergeData, AttachmentMergeData } from './activity.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Invoice,
    name: 'InvoiceAttachmentsMergeDataSchema',
})
export class InvoiceAttachmentsMergeData {
    @MergeField({
        arraySchemaName: 'AttachmentMergeSchema',
        ignoreFields: ['thumbnail', 'shared', 'tags']
    })
    mediaAttachments: AttachmentMergeData[] = [];

    @MergeField({
        arraySchemaName: 'AttachmentMergeSchema',
        ignoreFields: ['thumbnail', 'shared', 'tags']
    })
    fileAttachments: AttachmentMergeData[] = [];
}

export const InvoiceAttachmentsMergeDataSchema = getSchema(InvoiceAttachmentsMergeData)

@MergeSchema({
    entity: ActivityEntityName.Invoice,
})
export class InvoiceActivitiesMergeData {
    @MergeField({
        arraySchemaName: 'ActivityMergeSchema'
    })
    activities: ActivityMergeData[] = [];
}

export const InvoiceActivitiesMergeDataSchema = getSchema(InvoiceActivitiesMergeData)